export enum Status {
  new = 'New',
  matchRequested = 'MatchRequested',
  matchApproved = 'MatchApproved',
}
